module.exports = __webpack_public_path__ + "img/dataMiddleground-charafunction5.27eb0598.png";